import styled from "styled-components";

export const StickyContainer = styled("div")(({ theme }) => ({
  position: "sticky",
  top: 100,
  width: 320,
  flexShrink: 0, // иначе ширину съедает соседняя колонка с формой

  [theme.down("xl")]: {
    width: 270,
  },

  [theme.down("lg")]: {
    width: "100%",
    position: "relative",
    top: 0,
  },
}));

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(24),
  gap: 10,
  backgroundColor: "#fff",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  borderRadius: "8px",
  border: "1px solid #f0f0f0",

  [theme.down("lg")]: {
    marginBottom: 80,
  },
}));

export const Header = styled("div")(({ theme }) => ({
  padding: "20px 10px",
  borderBottom: "1px solid #e0e0e0",
}));

export const Title = styled("h4")(({ theme, $isSmallText }) => ({
  fontSize: "16px",
  fontWeight: "600",
  color: "#1a1a1a",
}));

export const PriceItem = styled("div")(({ theme, $isSmallText }) => ({
  ...theme.mixins.flexCenterBetween,
  gap: 8,

  // разряды в сумме разделены пробелом, без этого цена рвётся на несколько строк
  "& > span:last-child": {
    whiteSpace: "nowrap",
  },

  fontSize: $isSmallText ? 14 : 18,
  color: "#4a4a4a",

  "& > .price__footer": {
    fontSize: "15px",
    fontWeight: "600",
    color: "#1a1a1a",
  },

  "& > .total__amount": {
    fontSize: "24px",
    fontWeight: "700",
    color: "#0052ff",
    letterSpacing: "-0.5px",
  },

  [theme.down("md")]: {
    "& > .total__amount": {
      fontSize: "22px",
    },
  },

  [theme.down("sm")]: {
    fontSize: $isSmallText ? 12 : 15,

    "& > .price__footer": {
      fontSize: "14px",
    },

    "& > .total__amount": {
      fontSize: "18px",
    },
  },

  [theme.down("xs")]: {
    fontSize: $isSmallText ? 11 : 13,

    "& > .price__footer": {
      fontSize: "13px",
    },

    "& > .total__amount": {
      fontSize: "16px",
    },
  },
}));

export const LineDivider = styled("div")(({ theme }) => ({
  width: "100%",
  height: 1,
  backgroundColor: "#e0e0e0",
  margin: "8px 0",
}));

export const InfoIcon = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 16,
  height: 16,
  borderRadius: "50%",
  backgroundColor: "#e0e0e0",
  color: "#666",
  fontSize: 12,
  fontWeight: 600,
  marginLeft: 4,
  cursor: "help",
  transition: "all 0.2s ease",

  "&:hover": {
    backgroundColor: "#0052ff",
    color: "#fff",
  },
}));
